import React, { useCallback, useState, useMemo } from 'react';
import styles from './superGroups.module.scss';
import Button from '../../../components/button/Button';
import { BodyColumn, HeaderColumn } from '../../../components/table/Table';
import { SchoolGroup } from '../../../types';
import AddModal from './add-modal/AddModal';
import IconPencil from '../../../assets/icons/pencil.svg?react';
// import IconTrash from '../../../assets/icons/trash.svg?react';
import { gql, useQuery } from '@apollo/client';
import { useClientPagination } from '../../../hooks/useClientPagination';
import { AdminGrid } from '../../../components/admin-grid';
import AdminTable from '../../../components/admin-grid/AdminTable';

type Props = {};

export const GroupsQuery = gql`
  query GetSpecialPrograms {
    listGroups {
      id
      name
    }
  }
`;

export type GroupsResponse = {
  listGroups: SchoolGroup[];
};

function filterGroups(search: string) {
  const s = search.toLowerCase();
  return (c: SchoolGroup) => {
    if (c.name.toLowerCase().includes(s)) return true;
    return false;
  };
}

function SuperGroups(props: Props) {

  const { data, loading } = useQuery<GroupsResponse>(GroupsQuery);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // const [search, setSearch] = useState('');
  const [group, setGroup] = useState<SchoolGroup | undefined>(undefined);
  const [perPage] = useState(50);
  const filter = useCallback((arr) => {
    return arr.filter(filterGroups(''));
  }, [/*search*/]);

  const { dataSlice, totalFilteredItems, currentPage, onChangePage } = useClientPagination({
    data: data?.listGroups,
    perPage,
    onFilter: filter,
  });

  const handleOpenModal = () => setShowAddModal(true);
  const handleCloseModal = () => {
    setGroup(undefined)
    setShowDeleteModal(false)
    setShowAddModal(false);
  };
  const handleEditGroup = useCallback((row: SchoolGroup) => () => {
    setGroup(row);
    handleOpenModal();
  }, []);

  // const handleRemoveGroup = useCallback((row: SchoolGroup) => () => {
  //   setGroup(row);
  //   setShowDeleteModal(true)
  //   handleOpenModal();
  // }, []);

  // const handleChangeSearch = (value: string) => setSearch(value);

  const handleOpenAddNew = () => {
    handleOpenModal();
  };

  const headerColumns: HeaderColumn[] = useMemo(() => {
    return [
      { title: 'Group' },
      { title: 'Edit', right: true }
    ]
  }, []);

  const bodyColumns: BodyColumn[] = useMemo(() => {
    return [
      { key: 'name' },
      {
        key: (row: SchoolGroup) => {
          return (
            <div className={styles.actionWrapper}>
              <div className={styles.action} onClick={handleEditGroup(row)}>
                <IconPencil/>
              </div>
            </div>
          );
        },
        className: styles.editColumn
      }
    ]
  }, [handleEditGroup]);

  const handleChangePage = (page: number) => {
    onChangePage(page);
  };

  const hasData = !loading && data?.listGroups?.length !== 0;

  return (
    <>
      <AdminGrid
        title="Groups"
        headerActions={
          <Button 
            onClick={handleOpenAddNew} 
            className={styles.addBtn} 
            label={'NEW GROUPS'}
          />
        }
      >
        {hasData || loading ? (
          <div className={loading ? styles.loadingContainer : ''}>
            <AdminTable
              header={headerColumns}
              body={bodyColumns}
              data={dataSlice}
              loading={loading}
              currentPage={currentPage}
              perPage={perPage}
              totalItems={totalFilteredItems}
              onPageChange={handleChangePage}
              color="green"
              noItemsText="No groups found."
            />
          </div>
        ) : (
          <div className={styles.hasNoDataWrapper}>
            <div className={styles.hasNoData}>
              <div className={styles.hasNoDataText}>
                <div>The list is empty for now.</div>
                <div>You can add a groups by clicking</div>
              </div>
              <Button onClick={handleOpenAddNew} className={styles.addBtn} label={'Add new'}/>
            </div>
          </div>
        )}
      </AdminGrid>
      {showAddModal && <AddModal open={showAddModal} onClose={handleCloseModal} group={group} deleteOption={showDeleteModal}/>}
    </>
  );
}

export default SuperGroups;
